import extractMicrioUrlParts from '../utilities/extract-micrio-url-parts.js'

export default function anchorClickHandler(href = '', event = {}) {
  //console.log('click', href, event)

  if (!href || event.target.classList.contains('prevent-handler')) {
    return
  }

  if (href.indexOf('#') !== -1) {
    event?.preventDefault()

    const target = href.split('#')[1]
    const targetElement = document.getElementById(target)

    if (!targetElement) {
      return
    }

    if (targetElement.classList.contains('landing-themes__theme--active')) {
      window.scrollTo(0, 0)
      return
    }

    if (document.querySelector('.landing-themes__theme--active')) {
      window.dispatchEvent(new CustomEvent('close-theme-overlay'))
      //document.querySelector('.landing-themes__theme--active').classList.remove('landing-themes__theme--active')
      window.scrollTo({ top: targetElement.offsetTop || 0 })
      return
    }

    window.scrollTo({ top: targetElement.offsetTop || 0, behavior: 'smooth' })
  } else if (href.indexOf('.micr.io') !== -1) {
    event?.preventDefault()

    //const id = /(?:.*\.micr\.io\/)([a-zA-Z0-9]{5})(?:\/|$)/g.exec(href)[1]
    const urlParts = extractMicrioUrlParts(href)
    const id = urlParts.objectId
    const isObject = !urlParts.tourSlug
    //console.log(urlParts, isObject)

    window.dispatchEvent(new CustomEvent('micrio-overlay', { detail: { id, isObject } }))
  }
}
